import { FC, useMemo } from "react"
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"

import { formatFiatCurrency } from "util/formatter"

import { BAR_COLORS } from "./helpers"

export interface ChartItem {
  name: string
  ggr: number
}

export const GgrBarChart: FC<{ items: ChartItem[] }> = ({ items }) => {
  const chartData = useMemo(() => items.slice(0, 12), [items])

  return (
    <div className="h-[260px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 8, right: 16, left: 8, bottom: 4 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" />
          <XAxis dataKey="name" tick={{ fill: "#9ca3af", fontSize: 11 }} interval={0} angle={-30} textAnchor="end" height={60} />
          <YAxis tick={{ fill: "#9ca3af", fontSize: 11 }} tickFormatter={(v: number) => formatFiatCurrency(v, "$0") || "$0"} width={80} />
          <Tooltip
            contentStyle={{ background: "#1f2937", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8 }}
            labelStyle={{ color: "#e5e7eb" }}
            formatter={(value: number) => [formatFiatCurrency(value, "$0.00"), "GGR"]}
          />
          <Bar dataKey="ggr" radius={[4, 4, 0, 0]}>
            {chartData.map((_, idx) => (
              <Cell key={idx} fill={BAR_COLORS[idx % BAR_COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
